import React, { Component } from 'react';
import { Field, Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../../common/formElements/CustomSelect';
import CustomLoader from '../../common/CustomLoader';
import { drapcodeIcon } from '../../../common/custom/icon-library';

export default class GithubUserData extends Component {
  componentDidMount() {
    const { actions, projectId, version } = this.props;
    console.log('These are the props in the github user data: ', this.props);
    console.log('THis is the version that is being passed: ', version);
    actions.loadGithubUserData({ projectId, version });
  }

  handlePushToGithub = async (values) => {
    if (!values.selectedRepo || !values.exportSettingName.trim()) {
      return toast.error('Please fill in all required fields.');
    }
    const { actions, projectId, version } = this.props;
    actions.createGithubExportSetting({ projectId, body: values, version });
  };
  render() {
    const { deploymentSetting, isReadOnly } = this.props;
    const { githubUserData, loadGithubUserDataError, loadGithubUserDataPending, githubRepoData } =
      deploymentSetting;
    if (loadGithubUserDataError) {
      return (
        <div className="d-flex align-items-center justify-content-evenly">
          <strong>{loadGithubUserDataError}</strong>&nbsp;&nbsp;
          <a
            href={isReadOnly ? undefined : `${process.env.REACT_APP_ORGANIZATION}profile`}
            className={`btn btn-theme-primary ${isReadOnly ? 'disabled' : ''}`}
            title={isReadOnly ? 'Read-Only Mode' : 'Authorize Github'}
            onClick={(e) => isReadOnly && e.preventDefault()}
          >
            <i className={`wb ${drapcodeIcon('github')}`}></i> Authorize Github
          </a>
        </div>
      );
    }
    const repositoryOptions = githubRepoData.map((repo) => ({
      label: `${repo.name} ${repo.private ? '(Private)' : '(Public)'}`,
      value: repo, // Ensure this is the full repo object
    }));
    return (
      <>
        <div className="row align-items-center">
          <div className="col-md-3 col-sm-6 col-12 border-right text-center">
            {loadGithubUserDataPending && (
              <CustomLoader loading={loadGithubUserDataPending} size="20px" color="#303453" />
            )}
            {githubUserData && (
              <div className="d-flex flex-column align-items-center justify-content-between mb-3">
                <img
                  src={githubUserData.avatar_url}
                  alt="GitHub Avatar"
                  className="rounded-circle mr-3"
                  style={{ width: '100px', height: '100px' }}
                />
                <p className="mb-0">
                  Logged in as <strong className="text-muted">{githubUserData.login}</strong>
                </p>
              </div>
            )}
          </div>
          <div className="col-md-9 col-sm-6 col-12">
            <Formik
              initialValues={{
                exportSettingName: '',
                selectedRepo: '',
              }}
              onSubmit={(values, { setSubmitting }) => {
                this.handlePushToGithub(values);
              }}
            >
              {({ setFieldValue, setFieldTouched, values }) => (
                <Form className="form-horizontal">
                  <CustomInputWithIcon title="Export Setting Name" icon="text" required={true}>
                    <Field
                      type="text"
                      name="exportSettingName"
                      placeholder="Enter GitHub Export Setting Name"
                      value={values.exportSettingName}
                      className="form-control form-control-sm"
                    />
                  </CustomInputWithIcon>
                  <CustomInputWithIcon title="Select Repository" icon="select" required={true}>
                    <CustomSelect
                      name="selectedRepo"
                      isMulti={false}
                      options={repositoryOptions}
                      value={values.selectedRepo}
                      placeholder="Select a Repository"
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                      }}
                    />
                  </CustomInputWithIcon>
                  <div className="col-md-12 col-lg-12 mt-2 text-right d-flex justify-content-between align-items-center ">
                    <button type="reset" className="btn btn-outline btn-md">
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-theme-submit btn-md"
                      disabled={isReadOnly}
                      title={isReadOnly && 'Read-Only Mode'}
                    >
                      <i className="wb webconnect-save-regular"></i>&nbsp;Save
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </>
    );
  }
}
